/**
 * Taška★ bag-with-star-inside glyph (D17 / NEW G8).
 * Distinct from FavoriteStarIcon (SP ★) — never reuse star-only as bag-in.
 */
export function BagStarIcon({
  filled,
  className = 'h-5 w-5',
}: {
  readonly filled: boolean;
  readonly className?: string;
}): JSX.Element {
  return (
    <svg
      className={className}
      viewBox="0 0 24 24"
      aria-hidden="true"
      focusable="false"
      fill="none"
    >
      <path
        d="M6 8h12l-1.2 11H7.2L6 8Z"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinejoin="round"
        fill={filled ? 'currentColor' : 'none'}
        fillOpacity={filled ? 0.18 : 0}
      />
      <path
        d="M9 8V6a3 3 0 0 1 6 0v2"
        stroke="currentColor"
        strokeWidth="1.75"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M12 11.1l0.85 1.75 1.9.25-1.4 1.3.35 1.9L12 15.35l-1.7.95.35-1.9-1.4-1.3 1.9-.25L12 11.1z"
        fill="currentColor"
        stroke="none"
      />
    </svg>
  );
}
